import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 8 10"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  x: ".898",
  y: ".7",
  width: "1.4",
  height: "8.6",
  rx: ".7",
  fill: "currentColor",
  stroke: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  x: "5.699",
  y: ".7",
  width: "1.4",
  height: "8.6",
  rx: ".7",
  fill: "currentColor",
  stroke: "currentColor"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }